const ui = {
  dataTable: {
    rowActions: {
      edit: 'Editar',
      deactivate: 'Inativar',
      reactivate: 'Reativar',
    },
    filters: {
      title: 'Filtros',
      clearSearch: 'Limpar busca',
      openFilters: 'Abrir filtros',
      applyFilters: 'Aplicar Filtros',
      close: 'Fechar',
      noResults: 'Nenhum resultado encontrado.',
      all: 'Todos',
      allSports: 'Todos Esportes',
      allCategories: 'Todas Categorias',
    },
    mobileEmptyMessage: 'Nenhum resultado encontrado.',
  },
  combobox: {
    placeholder: 'Selecionar...',
    searchPlaceholder: 'Buscar...',
    emptyMessage: 'Nenhum resultado encontrado.',
  },
  datePicker: {
    placeholder: 'Selecione uma data',
    invalidDate: 'Data inválida',
    unavailableDate: 'Data indisponível para esta seleção',
  },
  input: {
    clearLabel: 'Limpar campo',
  },
  timePicker: {
    placeholder: 'Selecione um horário',
  },
  dateRangePicker: {
    placeholder: 'Selecione um período',
  },
  fileUpload: {
    maxFilesError: 'Você atingiu o limite máximo de arquivos permitidos para este campo.',
    tooSmallError: 'O arquivo é pequeno demais para ser processado.',
    unknownError: 'Erro desconhecido',
    maxSizeLabel: 'Máximo {{size}}',
    noSizeLimit: 'Sem limite de tamanho',
  },
  sidebar: {
    toggleExpand: 'Expandir barra lateral',
    toggleCollapse: 'Recolher barra lateral',
    update: 'Atualizar',
    updateTooltip: 'Atualizar aplicativo',
    signOut: 'Sair',
    signingOut: 'Saindo...',
    signOutTooltip: 'Sair',
  },
  themeSwitcher: {
    ariaLabel: 'Alternar tema',
  },
  scheduler: {
    previousWeek: 'Semana anterior',
    previousMonth: 'Mês anterior',
    previousDay: 'Dia anterior',
    nextWeek: 'Próxima semana',
    nextMonth: 'Próximo mês',
    nextDay: 'Próximo dia',
    outsideHours: 'Fora do horário de atendimento',
    blockedSlot: 'Horário bloqueado',
    blockedSlotReason: 'Bloqueado: {{reason}}',
  },
  bentoGrid: {
    learnMore: 'Saiba mais',
    comingSoon: 'Em breve',
  },
} as const
export default ui
